/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export function isEmpty(value) {
  if (value === undefined || value === "" || value === null) {
    return true;
  }
  return false;
}
export const validateBatteryId = (value, callback) => {
  if (isEmpty(value)) {
    return  false;
  }
  // if (value.length !=24 && value.length !=26 && value.length !=19) {
  //   return  false;
  // }
  let pattern = new RegExp("[A-Z0-9]");
  if (!pattern.test(value)) {
    return  false;
  }
  return true;

}





//身份证号合法性验证
//支持15位和18位身份证号
//支持地址编码、出生日期、校验位验证
export function validateIdentityCode(code) {
  let city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
  let tip = "";
  let pass= true;

  if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
    tip = "身份证号格式错误";
    pass = false;
  }

  else if(!city[code.substr(0,2)]){
    tip = "地址编码错误";
    pass = false;
  }
  else{
    //18位身份证需要验证最后一位校验位
    if(code.length == 18){
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      let factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
      //校验位
      let parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++)
      {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      let last = parity[sum % 11];
      if(parity[sum % 11] != code[17]){
        tip = "校验位错误";
        pass =false;
      }
    }
  }
  //if(!pass) alert(tip);
  return pass;
}
export function isPasswordValid(password) {
  const digitRegex = /\d/;
  const letterRegex = /[a-zA-Z]/;
  const specialCharRegex = /[@#$%^&*()\-_=+{}|;:,<.>/?!]/;
  const Reg = /^[^\s]*$/; //不能有空格
  const chineseCharRegex = /[\u4E00-\u9FFF]/; // 匹配中文字符

  const hasDigit = digitRegex.test(password);
  const hasLetter = letterRegex.test(password);
  const hasSpecialChar = specialCharRegex.test(password);
  const hasChineseChar = chineseCharRegex.test(password);
  const isValidLength = password.length > 8 && Reg.test(password) == true;

  const charClassesCount = [hasDigit, hasLetter, hasSpecialChar].filter(Boolean).length;

  return isValidLength && charClassesCount >= 2&&!hasChineseChar;
}

/**验证数字跟英文*/
export function validNumAndEng(str) {
  const regex = /^[a-zA-Z0-9]+$/
  return regex.test(str)
}
/**只能数字*/
export function validNumber(str) {
  const regex = /^-?\d+(\.\d+)?$/;
  return regex.test(str);
}


export function validMobile(str) {
  let phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;//手机号
  return  phoneReg.test(str)
}



export  function isValidIPv4(ip) {
  const regex = /^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/;
  return regex.test(ip);
}
export function executeValid(rule, value, callback) {
  if (!rule.validFunction(value,rule)) {
    callback(new Error(rule.message))
  } else {
    callback()
  }
}
/**长度验证*/
export function validLength(item,rule) {

  return rule.length>item.length
}




// WEBPACK FOOTER //
// ./src/utils/validate.js